import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LoadingSpinner } from '../ui/LoadingSpinner';
import { Page } from '../layout/Page';

const AUTH_PATHS = new Set(['/login', '/register', '/forgot-password', '/reset-password']);

/** Protects account/purchase routes. Catalog stays public; guests go straight to login. */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { ready, isAuthenticated, mode } = useAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <Page>
        <LoadingSpinner />
      </Page>
    );
  }

  // Telegram bootstrap already gated in App — still require a live session token
  // so we never hit authed APIs bare and get "Forbidden resource".
  if (mode === 'telegram') {
    if (!isAuthenticated) {
      return (
        <Page>
          <LoadingSpinner />
        </Page>
      );
    }
    return <>{children}</>;
  }

  if (!isAuthenticated) {
    if (AUTH_PATHS.has(location.pathname)) {
      return <>{children}</>;
    }
    const returnTo = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?returnTo=${encodeURIComponent(returnTo)}`} replace />;
  }

  return <>{children}</>;
}
